import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react";
import { LDSSidebar } from "@resmed/lumina-design-system";

interface HeaderOverride {
  title: string;
  onClose: () => void;
}

interface ChatSidebarHeaderContextValue {
  setHeaderOverride: (header: HeaderOverride | null) => void;
}

const ChatSidebarHeaderContext = createContext<ChatSidebarHeaderContextValue>({
  setHeaderOverride: () => undefined,
});

export const useChatSidebarHeader = () => useContext(ChatSidebarHeaderContext);

interface ChatSidebarProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

const ChatSidebar = ({ children, style }: ChatSidebarProps) => {
  const [visible, setVisible] = useState(true);
  const [headerOverride, setHeaderOverride] = useState<HeaderOverride | null>(null);

  const handleHide = useCallback(() => {
    if (headerOverride) {
      headerOverride.onClose();
      return;
    }

    setVisible(false);
    window.dispatchEvent(new CustomEvent("chat:sidebar-close"));
  }, [headerOverride]);

  return (
    <ChatSidebarHeaderContext.Provider value={{ setHeaderOverride }}>
      <LDSSidebar
        visible={visible}
        onHide={handleHide}
        position="right"
        size="large"
        headerTitle={headerOverride?.title ?? "Chat"}
        dismissable={false}
        closeOnEscape={true}
        fullScreenIcon={false}
        style={style}
      >
        {children}
      </LDSSidebar>
    </ChatSidebarHeaderContext.Provider>
  );
};

export default ChatSidebar;
